export type TargetedEnvironments = 'development' | 'integration' | 'production'

export const APP_ENV: TargetedEnvironments =
  (process.env.REACT_APP_ENV as TargetedEnvironments | undefined) ?? 'development'

export const CONTACT_MANAGER_ENDPOINT = process.env.REACT_APP_CONTACT_MANAGER_ENDPOINT

export const ACCOUNT_ORDERS_URL = process.env.REACT_APP_ACCOUNT_ORDERS_URL ?? ''

export const STORAGE_DOMAIN = process.env.REACT_APP_STORAGE_DOMAIN ?? 'localhost'

export const FEATURE_SHOW_MIAW_CHAT = process.env.REACT_APP_FEATURE_SHOW_MIAW_CHAT === 'true'

export const FEATURE_ENABLE_AF_CHAT = process.env.REACT_APP_FEATURE_ENABLE_AF_CHAT === 'true'
